import { Action } from "types/interface"

export const createAction = (type: string, value?: any): Action => ({
  type,
  value
})

// user
export const SET_MENU = 'user/set_menu'
export const SET_LOGINED = 'user/set_logined'
export const SET_USERINFO = 'user/set_userInfo'
export const SET_CALLING_CODE = 'user/set_calling_code'
export const SET_SHOW_AREA = 'user/set_show_area'
export const SET_UNREAD_NOTIFICATIONS = 'user/set_unread_notifications'
export const SET_LOGGING_IN = 'user/set_logging_in'

// recharge
export const SET_GOODS = 'recharge/set_goods'
export const SET_CURGOODS = 'recharge/set_curGoods'
export const SET_PAYTYPE = 'recharge/set_payType'
export const SET_PAYMENTS = 'recharge/set_payments'
export const SET_SOURCE = 'recharge/set_source'
export const SET_COUPON = 'recharge/set_coupon'
export const CAPTCHA_TYPE='recharge/captcha_type'
export const IS_DEFAULT_COUPON = 'recharge/is_default_coupon'

// affiliate
export const AFF_BALANCE = 'aff_balance'
export const AFF_WITHDRAWS = 'aff_withdraws'
export const AFF_AWARDS = 'aff_awards'

// invite
export const INVITE_INFO = 'invite_info'
export const INVITE_RECORDS = 'invite_records'
export const INVITE_DETAIL_RECORDS = 'invite_detail_records'

//links
export const LINKS = 'links'